var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Container, ContainerGutter } from '../container';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledFigure = styled.figure.withConfig({ displayName: "StyledFigure", componentId: "sc-1fg4r0g" }) `margin:0;`;
StyledFigure.displayName = 'StyledFigure';
export const Figure = (props) => {
    const { caption, captionAboveMedia, children } = props, rest = __rest(props, ["caption", "captionAboveMedia", "children"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledFigure, Object.assign({}, commonProps, rest),
        React.createElement(Container, { gutter: ContainerGutter.dynamic0020, wrap: "always" },
            caption && captionAboveMedia && React.createElement("figcaption", null, caption),
            children,
            caption && !captionAboveMedia && React.createElement("figcaption", null, caption))));
};
Figure.displayName = 'Figure';
